// Protected Route Component
import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

type ProtectedRouteProps = {
  children: ReactNode;
  requireSuperAdmin?: boolean;
};

export const ProtectedRoute = ({ children, requireSuperAdmin = false }: ProtectedRouteProps) => {
  const { user, profile, loading, isSuperAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner fullPage message="Loading..." />;
  }

  if (!user) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    // Redirect non-super-admins to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // Wait for profile to load
  if (!profile) {
    return <LoadingSpinner fullPage message="Loading profile..." />;
  }

  return <>{children}</>;
};
